import PropTypes from 'prop-types';
import { Card, CardContent, Stack, Button, Typography } from '@mui/material';
import Iconify from '../../../components/Iconify';

export default function AdminActionBar({ title, description, actions, onActionClick }) {
  return (
    <Card variant="outlined">
      <CardContent>
        <Stack
          direction={{ xs: 'column', lg: 'row' }}
          spacing={2}
          alignItems={{ xs: 'flex-start', lg: 'center' }}
          justifyContent="space-between"
        >
          <Stack spacing={0.5}>
            <Typography variant="subtitle1">{title}</Typography>
            <Typography variant="body2" color="text.secondary">
              {description}
            </Typography>
          </Stack>
          <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
            {actions.map((action) => (
              <Button
                key={action.label}
                color={action.color || 'inherit'}
                variant={action.variant || 'outlined'}
                startIcon={action.icon ? <Iconify icon={action.icon} /> : null}
                onClick={() => onActionClick(action)}
              >
                {action.label}
              </Button>
            ))}
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
}

AdminActionBar.propTypes = {
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      color: PropTypes.string,
      icon: PropTypes.string,
      label: PropTypes.string.isRequired,
      variant: PropTypes.string,
    })
  ).isRequired,
  description: PropTypes.string.isRequired,
  onActionClick: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
};
